var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOthers = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 14,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16.471,
  height: 2.471,
  fill: "#fff",
  rx: 1.235
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 16.471,
  height: 2.471,
  y: 5.765,
  fill: "#fff",
  rx: 1.235
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 16.471,
  height: 2.471,
  y: 11.529,
  fill: "#fff",
  rx: 1.235
})));
export default SvgOthers;